/** Classic string constants for Redux-Saga product catalog (maghil-portal style). */

export const PC = {
  // Items
  ITEMS_SET_EDITING: 'PC_ITEMS_SET_EDITING',
  ITEMS_SET_VISIBLE_COLUMNS: 'PC_ITEMS_SET_VISIBLE_COLUMNS',
  ITEMS_CLEAR_CACHE: 'PC_ITEMS_CLEAR_CACHE',
  FETCH_ITEMS_REQUEST: 'PC_FETCH_ITEMS_REQUEST',
  FETCH_ITEMS_SUCCESS: 'PC_FETCH_ITEMS_SUCCESS',
  FETCH_ITEMS_FAILURE: 'PC_FETCH_ITEMS_FAILURE',
  CREATE_ITEM_REQUEST: 'PC_CREATE_ITEM_REQUEST',
  CREATE_ITEM_SUCCESS: 'PC_CREATE_ITEM_SUCCESS',
  UPDATE_ITEM_REQUEST: 'PC_UPDATE_ITEM_REQUEST',
  UPDATE_ITEM_SUCCESS: 'PC_UPDATE_ITEM_SUCCESS',
  DELETE_ITEM_REQUEST: 'PC_DELETE_ITEM_REQUEST',
  DELETE_ITEM_SUCCESS: 'PC_DELETE_ITEM_SUCCESS',
  BULK_DELETE_ITEMS_REQUEST: 'PC_BULK_DELETE_ITEMS_REQUEST',
  BULK_DELETE_ITEMS_SUCCESS: 'PC_BULK_DELETE_ITEMS_SUCCESS',
  VALIDATE_ITEM_CODE_REQUEST: 'PC_VALIDATE_ITEM_CODE_REQUEST',
  VALIDATE_ITEM_CODE_SUCCESS: 'PC_VALIDATE_ITEM_CODE_SUCCESS',
  UPLOAD_ITEM_IMAGE_REQUEST: 'PC_UPLOAD_ITEM_IMAGE_REQUEST',
  UPLOAD_ITEM_IMAGE_SUCCESS: 'PC_UPLOAD_ITEM_IMAGE_SUCCESS',
  REMOVE_ITEM_IMAGE_REQUEST: 'PC_REMOVE_ITEM_IMAGE_REQUEST',
  REMOVE_ITEM_IMAGE_SUCCESS: 'PC_REMOVE_ITEM_IMAGE_SUCCESS',
  ITEMS_ADD: 'PC_ITEMS_ADD',
  ITEMS_UPDATE: 'PC_ITEMS_UPDATE',
  ITEMS_REMOVE: 'PC_ITEMS_REMOVE',
  ITEMS_TOGGLE_STATUS: 'PC_ITEMS_TOGGLE_STATUS',
  ITEMS_REORDER_IN_CATEGORY: 'PC_ITEMS_REORDER_IN_CATEGORY',

  // Categories
  CATEGORIES_SET_EDITING: 'PC_CATEGORIES_SET_EDITING',
  CATEGORIES_CLEAR_CACHE: 'PC_CATEGORIES_CLEAR_CACHE',
  FETCH_CATEGORIES_REQUEST: 'PC_FETCH_CATEGORIES_REQUEST',
  FETCH_CATEGORIES_SUCCESS: 'PC_FETCH_CATEGORIES_SUCCESS',
  FETCH_CATEGORIES_FAILURE: 'PC_FETCH_CATEGORIES_FAILURE',
  CATEGORIES_PRIME: 'PC_CATEGORIES_PRIME',
  CATEGORIES_SET_LOADING: 'PC_CATEGORIES_SET_LOADING',
  CREATE_CATEGORY_REQUEST: 'PC_CREATE_CATEGORY_REQUEST',
  CREATE_CATEGORY_SUCCESS: 'PC_CREATE_CATEGORY_SUCCESS',
  CREATE_CATEGORY_FAILURE: 'PC_CREATE_CATEGORY_FAILURE',
  UPDATE_CATEGORY_REQUEST: 'PC_UPDATE_CATEGORY_REQUEST',
  UPDATE_CATEGORY_SUCCESS: 'PC_UPDATE_CATEGORY_SUCCESS',
  UPDATE_CATEGORY_FAILURE: 'PC_UPDATE_CATEGORY_FAILURE',
  DELETE_CATEGORY_REQUEST: 'PC_DELETE_CATEGORY_REQUEST',
  DELETE_CATEGORY_SUCCESS: 'PC_DELETE_CATEGORY_SUCCESS',
  DELETE_CATEGORY_FAILURE: 'PC_DELETE_CATEGORY_FAILURE',
  SORT_CATEGORIES_REQUEST: 'PC_SORT_CATEGORIES_REQUEST',
  SORT_CATEGORIES_SUCCESS: 'PC_SORT_CATEGORIES_SUCCESS',
  SORT_CATEGORIES_FAILURE: 'PC_SORT_CATEGORIES_FAILURE',
  CATEGORIES_ADD: 'PC_CATEGORIES_ADD',
  CATEGORIES_UPDATE: 'PC_CATEGORIES_UPDATE',
  CATEGORIES_REMOVE: 'PC_CATEGORIES_REMOVE',
  CATEGORIES_TOGGLE_VISIBILITY: 'PC_CATEGORIES_TOGGLE_VISIBILITY',
  CATEGORIES_REORDER_SIBLINGS: 'PC_CATEGORIES_REORDER_SIBLINGS',

  // Menus
  MENUS_SET_EDITING: 'PC_MENUS_SET_EDITING',
  MENUS_CLEAR_CACHE: 'PC_MENUS_CLEAR_CACHE',
  FETCH_MENUS_REQUEST: 'PC_FETCH_MENUS_REQUEST',
  FETCH_MENUS_SUCCESS: 'PC_FETCH_MENUS_SUCCESS',
  FETCH_MENUS_FAILURE: 'PC_FETCH_MENUS_FAILURE',
  CREATE_MENU_REQUEST: 'PC_CREATE_MENU_REQUEST',
  CREATE_MENU_SUCCESS: 'PC_CREATE_MENU_SUCCESS',
  CREATE_MENU_FAILURE: 'PC_CREATE_MENU_FAILURE',
  UPDATE_MENU_REQUEST: 'PC_UPDATE_MENU_REQUEST',
  UPDATE_MENU_SUCCESS: 'PC_UPDATE_MENU_SUCCESS',
  UPDATE_MENU_FAILURE: 'PC_UPDATE_MENU_FAILURE',
  DELETE_MENU_REQUEST: 'PC_DELETE_MENU_REQUEST',
  DELETE_MENU_SUCCESS: 'PC_DELETE_MENU_SUCCESS',
  DELETE_MENU_FAILURE: 'PC_DELETE_MENU_FAILURE',
  MENUS_ADD: 'PC_MENUS_ADD',
  MENUS_UPDATE: 'PC_MENUS_UPDATE',
  MENUS_REMOVE: 'PC_MENUS_REMOVE',

  // Sessions
  SESSIONS_SET_EDITING: 'PC_SESSIONS_SET_EDITING',
  SESSIONS_CLEAR_CACHE: 'PC_SESSIONS_CLEAR_CACHE',
  FETCH_SESSIONS_REQUEST: 'PC_FETCH_SESSIONS_REQUEST',
  FETCH_SESSIONS_SUCCESS: 'PC_FETCH_SESSIONS_SUCCESS',
  FETCH_SESSIONS_FAILURE: 'PC_FETCH_SESSIONS_FAILURE',
  CREATE_SESSION_REQUEST: 'PC_CREATE_SESSION_REQUEST',
  CREATE_SESSION_SUCCESS: 'PC_CREATE_SESSION_SUCCESS',
  UPDATE_SESSION_REQUEST: 'PC_UPDATE_SESSION_REQUEST',
  UPDATE_SESSION_SUCCESS: 'PC_UPDATE_SESSION_SUCCESS',
  DELETE_SESSION_REQUEST: 'PC_DELETE_SESSION_REQUEST',
  DELETE_SESSION_SUCCESS: 'PC_DELETE_SESSION_SUCCESS',
  SESSIONS_ADD: 'PC_SESSIONS_ADD',
  SESSIONS_UPDATE: 'PC_SESSIONS_UPDATE',
  SESSIONS_REMOVE: 'PC_SESSIONS_REMOVE',

  // Modifiers
  MODIFIERS_SET_EDITING: 'PC_MODIFIERS_SET_EDITING',
  MODIFIERS_CLEAR_CACHE: 'PC_MODIFIERS_CLEAR_CACHE',
  FETCH_MODIFIERS_REQUEST: 'PC_FETCH_MODIFIERS_REQUEST',
  FETCH_MODIFIERS_SUCCESS: 'PC_FETCH_MODIFIERS_SUCCESS',
  FETCH_MODIFIERS_FAILURE: 'PC_FETCH_MODIFIERS_FAILURE',
  CREATE_MODIFIER_REQUEST: 'PC_CREATE_MODIFIER_REQUEST',
  CREATE_MODIFIER_SUCCESS: 'PC_CREATE_MODIFIER_SUCCESS',
  CREATE_MODIFIER_FAILURE: 'PC_CREATE_MODIFIER_FAILURE',
  UPDATE_MODIFIER_REQUEST: 'PC_UPDATE_MODIFIER_REQUEST',
  UPDATE_MODIFIER_SUCCESS: 'PC_UPDATE_MODIFIER_SUCCESS',
  UPDATE_MODIFIER_FAILURE: 'PC_UPDATE_MODIFIER_FAILURE',
  DELETE_MODIFIER_REQUEST: 'PC_DELETE_MODIFIER_REQUEST',
  DELETE_MODIFIER_SUCCESS: 'PC_DELETE_MODIFIER_SUCCESS',
  DELETE_MODIFIER_FAILURE: 'PC_DELETE_MODIFIER_FAILURE',
  MODIFIERS_ADD: 'PC_MODIFIERS_ADD',
  MODIFIERS_UPDATE: 'PC_MODIFIERS_UPDATE',
  MODIFIERS_REMOVE: 'PC_MODIFIERS_REMOVE',

  // Combos
  COMBOS_SET_EDITING: 'PC_COMBOS_SET_EDITING',
  COMBOS_CLEAR_CACHE: 'PC_COMBOS_CLEAR_CACHE',
  FETCH_COMBOS_REQUEST: 'PC_FETCH_COMBOS_REQUEST',
  FETCH_COMBOS_SUCCESS: 'PC_FETCH_COMBOS_SUCCESS',
  FETCH_COMBOS_FAILURE: 'PC_FETCH_COMBOS_FAILURE',
  CREATE_COMBO_REQUEST: 'PC_CREATE_COMBO_REQUEST',
  CREATE_COMBO_SUCCESS: 'PC_CREATE_COMBO_SUCCESS',
  CREATE_COMBO_FAILURE: 'PC_CREATE_COMBO_FAILURE',
  UPDATE_COMBO_REQUEST: 'PC_UPDATE_COMBO_REQUEST',
  UPDATE_COMBO_SUCCESS: 'PC_UPDATE_COMBO_SUCCESS',
  UPDATE_COMBO_FAILURE: 'PC_UPDATE_COMBO_FAILURE',
  DELETE_COMBO_REQUEST: 'PC_DELETE_COMBO_REQUEST',
  DELETE_COMBO_SUCCESS: 'PC_DELETE_COMBO_SUCCESS',
  DELETE_COMBO_FAILURE: 'PC_DELETE_COMBO_FAILURE',
  COMBOS_ADD: 'PC_COMBOS_ADD',
  COMBOS_UPDATE: 'PC_COMBOS_UPDATE',
  COMBOS_REMOVE: 'PC_COMBOS_REMOVE',

  // Option sets
  OPTION_SETS_SET_EDITING: 'PC_OPTION_SETS_SET_EDITING',
  OPTION_SETS_CLEAR_CACHE: 'PC_OPTION_SETS_CLEAR_CACHE',
  FETCH_OPTION_SETS_REQUEST: 'PC_FETCH_OPTION_SETS_REQUEST',
  FETCH_OPTION_SETS_SUCCESS: 'PC_FETCH_OPTION_SETS_SUCCESS',
  FETCH_OPTION_SETS_FAILURE: 'PC_FETCH_OPTION_SETS_FAILURE',
  CREATE_OPTION_SET_REQUEST: 'PC_CREATE_OPTION_SET_REQUEST',
  CREATE_OPTION_SET_SUCCESS: 'PC_CREATE_OPTION_SET_SUCCESS',
  CREATE_OPTION_SET_FAILURE: 'PC_CREATE_OPTION_SET_FAILURE',
  UPDATE_OPTION_SET_REQUEST: 'PC_UPDATE_OPTION_SET_REQUEST',
  UPDATE_OPTION_SET_SUCCESS: 'PC_UPDATE_OPTION_SET_SUCCESS',
  UPDATE_OPTION_SET_FAILURE: 'PC_UPDATE_OPTION_SET_FAILURE',
  DELETE_OPTION_SET_REQUEST: 'PC_DELETE_OPTION_SET_REQUEST',
  DELETE_OPTION_SET_SUCCESS: 'PC_DELETE_OPTION_SET_SUCCESS',
  DELETE_OPTION_SET_FAILURE: 'PC_DELETE_OPTION_SET_FAILURE',
  OPTION_SETS_ADD: 'PC_OPTION_SETS_ADD',
  OPTION_SETS_UPDATE: 'PC_OPTION_SETS_UPDATE',
  OPTION_SETS_REMOVE: 'PC_OPTION_SETS_REMOVE',

  // Kitchen stations
  KITCHEN_SET_EDITING: 'PC_KITCHEN_SET_EDITING',
  KITCHEN_CLEAR_CACHE: 'PC_KITCHEN_CLEAR_CACHE',
  FETCH_KITCHEN_REQUEST: 'PC_FETCH_KITCHEN_REQUEST',
  FETCH_KITCHEN_SUCCESS: 'PC_FETCH_KITCHEN_SUCCESS',
  FETCH_KITCHEN_FAILURE: 'PC_FETCH_KITCHEN_FAILURE',
  CREATE_STATION_REQUEST: 'PC_CREATE_STATION_REQUEST',
  CREATE_STATION_SUCCESS: 'PC_CREATE_STATION_SUCCESS',
  CREATE_STATION_FAILURE: 'PC_CREATE_STATION_FAILURE',
  UPDATE_STATION_REQUEST: 'PC_UPDATE_STATION_REQUEST',
  UPDATE_STATION_SUCCESS: 'PC_UPDATE_STATION_SUCCESS',
  UPDATE_STATION_FAILURE: 'PC_UPDATE_STATION_FAILURE',
  DELETE_STATION_REQUEST: 'PC_DELETE_STATION_REQUEST',
  DELETE_STATION_SUCCESS: 'PC_DELETE_STATION_SUCCESS',
  DELETE_STATION_FAILURE: 'PC_DELETE_STATION_FAILURE',
  KITCHEN_ADD_STATION: 'PC_KITCHEN_ADD_STATION',
  KITCHEN_UPDATE_STATION: 'PC_KITCHEN_UPDATE_STATION',
  KITCHEN_REMOVE_STATION: 'PC_KITCHEN_REMOVE_STATION',
  KITCHEN_ADD_PRINTER: 'PC_KITCHEN_ADD_PRINTER',
  KITCHEN_UPDATE_PRINTER: 'PC_KITCHEN_UPDATE_PRINTER',
  KITCHEN_REMOVE_PRINTER: 'PC_KITCHEN_REMOVE_PRINTER',

  // Item attributes
  FETCH_ATTRIBUTES_REQUEST: 'PC_FETCH_ATTRIBUTES_REQUEST',
  FETCH_ATTRIBUTES_SUCCESS: 'PC_FETCH_ATTRIBUTES_SUCCESS',
  FETCH_ATTRIBUTES_FAILURE: 'PC_FETCH_ATTRIBUTES_FAILURE',
  CLEAR_ATTRIBUTES: 'PC_CLEAR_ATTRIBUTES',

  // Toast
  TOAST_ADD: 'PC_TOAST_ADD',
  TOAST_REMOVE: 'PC_TOAST_REMOVE',

  // Set menus
  SET_MENUS_SET_EDITING: 'PC_SET_MENUS_SET_EDITING',
  SET_MENUS_ADD: 'PC_SET_MENUS_ADD',
  SET_MENUS_UPDATE: 'PC_SET_MENUS_UPDATE',
  SET_MENUS_REMOVE: 'PC_SET_MENUS_REMOVE',

  // Menu prices
  MENU_PRICES_SET: 'PC_MENU_PRICES_SET',
  MENU_PRICES_REMOVE: 'PC_MENU_PRICES_REMOVE',
  MENU_PRICES_REMOVE_ALL_MENU: 'PC_MENU_PRICES_REMOVE_ALL_MENU',
  MENU_PRICES_REMOVE_ALL_ITEM: 'PC_MENU_PRICES_REMOVE_ALL_ITEM',
  MENU_PRICES_BULK_ADJUST: 'PC_MENU_PRICES_BULK_ADJUST',

  // Dietary colors
  DIETARY_COLORS_UPDATE: 'PC_DIETARY_COLORS_UPDATE',

  // Sync trigger
  TRIGGER_SYNC_REQUEST: 'PC_TRIGGER_SYNC_REQUEST',
  TRIGGER_SYNC_SUCCESS: 'PC_TRIGGER_SYNC_SUCCESS',
  TRIGGER_SYNC_FAILURE: 'PC_TRIGGER_SYNC_FAILURE',

  // Cache invalidation
  INVALIDATE_FETCH_CACHE: 'PC_INVALIDATE_FETCH_CACHE',

  // Restaurant details (shared from DesktopLayout details API)
  RESTAURANT_DETAILS_SET: 'PC_RESTAURANT_DETAILS_SET',
  RESTAURANT_DETAILS_CLEAR: 'PC_RESTAURANT_DETAILS_CLEAR',

  // Module list bridge (forms)
  FETCH_MODULE_LIST_REQUEST: 'PC_FETCH_MODULE_LIST_REQUEST',
  FETCH_MODULE_LIST_SUCCESS: 'PC_FETCH_MODULE_LIST_SUCCESS',
} as const;
